import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Cookies from 'js-cookie';

import Video from 'app/windows/lib/rack-window/controls/Video';
import { Content, VideoLink, WrapperVideo } from './video-block.styled';

let w = 760;
let h = w * 0.778 + 'px';

const cookieName = 'main-video-active';

class VideoBlockCmp extends React.Component {
  constructor(props) {
    super(props);

    const active = Cookies.get(cookieName) === 'true';

    this.state = {
      active: active,
    };

    this.toggleVideo = this.toggleVideo.bind(this);
  }

  toggleVideo() {
    this.setState((state) => {
      Cookies.set(cookieName, !state.active);
      return { active: !state.active };
    });
  }

  render() {
    const { active } = this.state;
    if (!window.config.video) {
      return null;
    }
    const cameraID = this.props.cameraID;
    const node = this.props.node;
    if (!node || !cameraID) {
      return null;
    }
    const cameraUrl1 = node.cameras.main;
    const cameraUrl2 = node.cameras.face_upper;
    const v = moment().unix();
    const cl = active ? 'active' : '';

    const vurl1 = cameraUrl1; //window.config.network.http_url + '/getVideo/' + cameraUrl1 + '?key=' + v
    return (
      <Content>
        <VideoLink className={cl} onClick={this.toggleVideo} />
        {active && (
          <WrapperVideo>
            <Video
              height={h}
              params={{
                id: 'cam1' + cameraID,
                src: vurl1,
              }}
            />
            {cameraUrl2 && (
              <Video
                height={h}
                poster={window.config.network.http_url + '/getVideo/' + cameraUrl2 + '?key=' + v}
                params={{
                  id: 'cam3' + cameraID,
                  src: window.config.network.http_url + '/getVideo/' + cameraUrl2 + '?key=' + v,
                }}
              />
            )}
          </WrapperVideo>
        )}
      </Content>
    );
  }
}

function mapStateToProps(store) {
  return {
    signals: store.events.events,
  };
}

export const VideoBlock = connect(mapStateToProps)(VideoBlockCmp);
